module.exports = __webpack_public_path__ + "static/media/rupioologo.3c86e8bf.png";